import { ChangeDetectorRef, EventEmitter, Output } from "@angular/core";
import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { FormGroup, FormArray, FormBuilder, FormControl } from "@angular/forms";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from "@angular/material/dialog";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { BehaviorSubject } from "rxjs";
import { ControlUser } from "../model/controlUser";
import { Overlay } from "@angular/cdk/overlay";
import { DevicePilomat } from "../model/devicePilomat";
import { AccessMethod } from "../model/accessMethod";
import { UserService } from "../service/user.service";
import { Log } from "../util/log";
import { AccessMethodsGuideComponent } from "../access-methods-guide/access-methods-guide.component";
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { E } from "_node_modules/@angular/cdk/keycodes";
import { RemoteHelper } from "../util/remoteHelper";
import { Observable, of } from "_node_modules/rxjs";
import { map } from "rxjs/operators";
import { PhoneNumberUtil, PhoneNumber, PhoneNumberFormat } from 'google-libphonenumber';

@Component({
  selector: 'app-access-methods-editor',
  templateUrl: './access-methods-editor.component.html',
  styleUrls: ['./access-methods-editor.component.css']
})
export class AccessMethodsEditorComponent implements OnInit {
  phoneUtil = PhoneNumberUtil.getInstance();

  @ViewChild("accessmethodloader", { static: true }) loader;

  methods: AccessMethod[] = [];
  methodsToCheck: AccessMethod[] = [];
  accessMethodsForm: FormGroup;
  items: FormArray = new FormArray([]);
  typeList: string[] = AccessMethod.TYPE;
  accessMethodTypes: Array<any> = [];
  code: string;
  appCode: string;


  emptyCodeError: boolean;
  duplicateError: boolean;
  remoteCodeError: boolean;
  tooManyRemotesError: boolean;
  tooManyMethodsError: boolean;
  wrongPhoneNumberError: boolean;
  pincodeHasLettersError: boolean;
  pincodeLengthError: boolean;


  methodAlreadyUsedError: boolean;
  methodStr: string = '';

  maxRemotes: number = 15;
  maxMethods: number = 15;
  currentRemotes: number;

  userOwnerId: string;

  prefixes: Array<any> = [ //numeri contenenti i trattini rimossi per problemi di parsing
    { value: "+93", text: "Afghanistan +93" },
    { value: "+355", text: "Albania +355" },
    { value: "+213", text: "Algeria +213" },
    // { value: "+1-684", text: "American Samoa +1-684" },
    { value: "+376", text: "Andorra +376" },
    { value: "+244", text: "Angola +244" },
    { value: "+1-264", text: "Anguilla +1-264" },
    { value: "+672", text: "Antarctica +672" },
    { value: "+1-268", text: "Antigua +1-268" },
    { value: "+54", text: "Argentina +54" },
    { value: "+374", text: "Armenia +374" },
    { value: "+297", text: "Aruba +297" },
    { value: "+247", text: "Ascension +247" },
    { value: "+61", text: "Australia +61" },
    { value: "+672", text: "Australian Ext. Territories +672" },
    { value: "+43", text: "Austria +43" },
    { value: "+994", text: "Azerbaijan +994" },
    // // { value: "+1-242", text: "Bahamas +1-242" },
    { value: "+973", text: "Bahrain +973" },
    { value: "+880", text: "Bangladesh +880" },
    // // { value: "+1-246", text: "Barbados +1-246" },
    // // { value: "+1-268", text: "Barbuda +1-268" },
    { value: "+375", text: "Belarus +375" },
    { value: "+32", text: "Belgium +32" },
    { value: "+501", text: "Belize +501" },
    { value: "+229", text: "Benin +229" },
    // // { value: "+1-441", text: "Bermuda +1-441" },
    { value: "+975", text: "Bhutan +975" },
    { value: "+591", text: "Bolivia +591" },
    { value: "+387", text: "Bosnia & Herzegovina +387" },
    { value: "+267", text: "Botswana +267" },
    { value: "+55", text: "Brazil +55" },
    // // { value: "+1-284", text: "British Virgin Islands +1-284" },
    { value: "+673", text: "Brunei Darussalam +673" },
    { value: "+359", text: "Bulgaria +359" },
    { value: "+226", text: "Burkina Faso +226" },
    { value: "+257", text: "Burundi +257" },
    { value: "+855", text: "Cambodia +855" },
    { value: "+237", text: "Cameroon +237" },
    { value: "+1", text: "Canada +1" },
    { value: "+238", text: "Cape Verde Islands +238" },
    // // { value: "+1-345", text: "Cayman Islands +1-345" },
    { value: "+236", text: "Central African Republic +236" },
    { value: "+235", text: "Chad +235" },
    { value: "+64", text: "Chatham Island (NZ) +64" },
    { value: "+56", text: "Chile +56" },
    { value: "+86", text: "China (PRC) +86" },
    // // { value: "+61-8", text: "Christmas Island +61-8" },
    // { value: "+61", text: "Cocos-Keeling Islands +61" },
    { value: "+57", text: "Colombia +57" },
    { value: "+269", text: "Comoros +269" },
    { value: "+242", text: "Congo +242" },
    { value: "+243", text: "Congo, Dem. Rep. of +243" },
    { value: "+682", text: "Cook Islands +682" },
    { value: "+506", text: "Costa Rica +506" },
    { value: "+225", text: "Côte d'Ivoire (Ivory Coast) +225" },
    { value: "+385", text: "Croatia +385" },
    { value: "+53", text: "Cuba +53" },
    { value: "+5399", text: "Cuba (Guantanamo Bay) +5399" },
    { value: "+599", text: "Curaçao +599" },
    { value: "+357", text: "Cyprus +357" },
    { value: "+420", text: "Czech Republic +420" },
    { value: "+45", text: "Denmark +45" },
    { value: "+246", text: "Diego Garcia +246" },
    { value: "+253", text: "Djibouti +253" },
    // // { value: "+1-767", text: "Dominica +1-767" },
    // // { value: "+1-809", text: "Dominican Republic +1-809" },
    { value: "+670", text: "East Timor +670" },
    { value: "+56", text: "Easter Island +56" },
    { value: "+593", text: "Ecuador +593" },
    { value: "+20", text: "Egypt +20" },
    { value: "+503", text: "El Salvador +503" },
    { value: "+240", text: "Equatorial Guinea +240" },
    { value: "+291", text: "Eritrea +291" },
    { value: "+372", text: "Estonia +372" },
    { value: "+251", text: "Ethiopia +251" },
    { value: "+500", text: "Falkland Islands (Malvinas) +500" },
    { value: "+298", text: "Faroe Islands +298" },
    { value: "+679", text: "Fiji Islands +679" },
    { value: "+358", text: "Finland +358" },
    { value: "+33", text: "France +33" },
    { value: "+596", text: "French Antilles +596" },
    { value: "+594", text: "French Guiana +594" },
    { value: "+689", text: "French Polynesia +689" },
    { value: "+241", text: "Gabonese Republic +241" },
    { value: "+220", text: "Gambia +220" },
    { value: "+995", text: "Georgia +995" },
    { value: "+49", text: "Germany +49" },
    { value: "+233", text: "Ghana +233" },
    { value: "+350", text: "Gibraltar +350" },
    { value: "+30", text: "Greece +30" },
    { value: "+299", text: "Greenland +299" },
    // // { value: "+1-473", text: "Grenada +1-473" },
    { value: "+590", text: "Guadeloupe +590" },
    // // { value: "+1-671", text: "Guam +1-671" },
    { value: "+5399", text: "Guantanamo Bay +5399" },
    { value: "+502", text: "Guatemala +502" },
    { value: "+245", text: "Guinea-Bissau +245" },
    { value: "+224", text: "Guinea +224" },
    { value: "+592", text: "Guyana +592" },
    { value: "+509", text: "Haiti +509" },
    { value: "+504", text: "Honduras +504" },
    { value: "+852", text: "Hong Kong +852" },
    { value: "+36", text: "Hungary +36" },
    { value: "+354", text: "Iceland +354" },
    { value: "+91", text: "India +91" },
    { value: "+62", text: "Indonesia +62" },
    { value: "+98", text: "Iran +98" },
    { value: "+964", text: "Iraq +964" },
    { value: "+353", text: "Ireland +353" },
    { value: "+972", text: "Israel +972" },
    { value: "+39", text: "Italy +39" },
    // // { value: "+1-876", text: "Jamaica +1-876" },
    { value: "+81", text: "Japan +81" },
    { value: "+962", text: "Jordan +962" },
    { value: "+7", text: "Kazakhstan +7" },
    { value: "+254", text: "Kenya +254" },
    { value: "+686", text: "Kiribati +686" },
    { value: "+850", text: "Korea (North) +850" },
    { value: "+82", text: "Korea (South) +82" },
    { value: "+965", text: "Kuwait +965" },
    { value: "+996", text: "Kyrgyz Republic +996" },
    { value: "+856", text: "Laos +856" },
    { value: "+371", text: "Latvia +371" },
    { value: "+961", text: "Lebanon +961" },
    { value: "+266", text: "Lesotho +266" },
    { value: "+231", text: "Liberia +231" },
    { value: "+218", text: "Libya +218" },
    { value: "+423", text: "Liechtenstein +423" },
    { value: "+370", text: "Lithuania +370" },
    { value: "+352", text: "Luxembourg +352" },
    { value: "+853", text: "Macao +853" },
    { value: "+389", text: "Macedonia +389" },
    { value: "+261", text: "Madagascar +261" },
    { value: "+265", text: "Malawi +265" },
    { value: "+60", text: "Malaysia +60" },
    { value: "+960", text: "Maldives +960" },
    { value: "+223", text: "Mali Republic +223" },
    { value: "+356", text: "Malta +356" },
    { value: "+692", text: "Marshall Islands +692" },
    { value: "+596", text: "Martinique +596" },
    { value: "+222", text: "Mauritania +222" },
    { value: "+230", text: "Mauritius +230" },
    { value: "+269", text: "Mayotte Island +269" },
    { value: "+52", text: "Mexico +52" },
    { value: "+691", text: "Micronesia +691" },
    // // { value: "+1-808", text: "Midway Island +1-808" },
    { value: "+373", text: "Moldova +373" },
    { value: "+377", text: "Monaco +377" },
    { value: "+976", text: "Mongolia +976" },
    { value: "+382", text: "Montenegro +382" },
    // // { value: "+1-664", text: "Montserrat +1-664" },
    { value: "+212", text: "Morocco +212" },
    { value: "+258", text: "Mozambique +258" },
    { value: "+95", text: "Myanmar +95" },
    { value: "+264", text: "Namibia +264" },
    { value: "+674", text: "Nauru +674" },
    { value: "+977", text: "Nepal +977" },
    { value: "+31", text: "Netherlands +31" },
    { value: "+599", text: "Netherlands Antilles +599" },
    // // { value: "+1-869", text: "Nevis +1-869" },
    { value: "+687", text: "New Caledonia +687" },
    { value: "+64", text: "New Zealand +64" },
    { value: "+505", text: "Nicaragua +505" },
    { value: "+227", text: "Niger +227" },
    { value: "+234", text: "Nigeria +234" },
    { value: "+683", text: "Niue +683" },
    { value: "+672", text: "Norfolk Island +672" },
    // // { value: "+1-670", text: "Northern Marianas Isl. +1-670" },
    { value: "+47", text: "Norway +47" },
    { value: "+968", text: "Oman +968" },
    { value: "+92", text: "Pakistan +92" },
    { value: "+680", text: "Palau +680" },
    { value: "+970", text: "Palestinian Settlements +970" },
    { value: "+507", text: "Panama +507" },
    { value: "+675", text: "Papua New Guinea +675" },
    { value: "+595", text: "Paraguay +595" },
    { value: "+51", text: "Peru +51" },
    { value: "+63", text: "Philippines +63" },
    { value: "+48", text: "Poland +48" },
    { value: "+351", text: "Portugal +351" },
    // // { value: "+1-787", text: "Puerto Rico +1-787" },
    { value: "+974", text: "Qatar +974" },
    { value: "+262", text: "Réunion Island +262" },
    { value: "+40", text: "Romania +40" },
    { value: "+7", text: "Russia +7" },
    { value: "+250", text: "Rwandese Republic +250" },
    { value: "+290", text: "St. Helena +290" },
    // // { value: "+1-869", text: "St. Kitts/Nevis +1-869" },
    // // { value: "+1-758", text: "St. Lucia +1-758" },
    { value: "+508", text: "St. Pierre & Miquelon +508" },
    // // { value: "+1-784", text: "St. Vincent & Grenadines +1-784" },
    { value: "+685", text: "Samoa +685" },
    { value: "+378", text: "San Marino +378" },
    { value: "+239", text: "São Tomé and Principe +239" },
    { value: "+966", text: "Saudi Arabia +966" },
    { value: "+221", text: "Senegal +221" },
    { value: "+381", text: "Serbia +381" },
    { value: "+248", text: "Seychelles Republic +248" },
    { value: "+232", text: "Sierra Leone +232" },
    { value: "+65", text: "Singapore +65" },
    { value: "+421", text: "Slovak Republic +421" },
    { value: "+386", text: "Slovenia +386" },
    { value: "+677", text: "Solomon Islands +677" },
    { value: "+252", text: "Somali Democratic Republic +252" },
    { value: "+27", text: "South Africa +27" },
    { value: "+34", text: "Spain +34" },
    { value: "+94", text: "Sri Lanka +94" },
    { value: "+249", text: "Sudan +249" },
    { value: "+597", text: "Suriname +597" },
    { value: "+268", text: "Swaziland +268" },
    { value: "+46", text: "Sweden +46" },
    { value: "+41", text: "Switzerland +41" },
    { value: "+963", text: "Syria +963" },
    { value: "+886", text: "Taiwan +886" },
    { value: "+992", text: "Tajikistan +992" },
    { value: "+255", text: "Tanzania +255" },
    { value: "+66", text: "Thailand +66" },
    { value: "+670", text: "Timor Leste +670" },
    { value: "+228", text: "Togolese Republic +228" },
    { value: "+690", text: "Tokelau +690" },
    { value: "+676", text: "Tonga Islands +676" },
    // // { value: "+1-868", text: "Trinidad & Tobago +1-868" },
    { value: "+216", text: "Tunisia +216" },
    { value: "+90", text: "Turkey +90" },
    { value: "+993", text: "Turkmenistan +993" },
    // // { value: "+1-649", text: "Turks and Caicos Islands +1-649" },
    { value: "+688", text: "Tuvalu +688" },
    { value: "+256", text: "Uganda +256" },
    { value: "+380", text: "Ukraine +380" },
    { value: "+971", text: "United Arab Emirates +971" },
    { value: "+44", text: "United Kingdom +44" },
    { value: "+1", text: "United States of America +1" },
    // // { value: "+1-340", text: "US Virgin Islands +1-340" },
    { value: "+598", text: "Uruguay +598" },
    { value: "+998", text: "Uzbekistan +998" },
    { value: "+678", text: "Vanuatu +678" },
    { value: "+379", text: "Vatican City +379" },
    { value: "+58", text: "Venezuela +58" },
    { value: "+84", text: "Vietnam +84" },
    { value: "+808", text: "Wake Island +808" },
    { value: "+681", text: "Wallis and Futuna Isl. +681" },
    { value: "+967", text: "Yemen +967" },
    { value: "+260", text: "Zambia +260" },
    { value: "+255", text: "Zanzibar +255" },
    { value: "+263", text: "Zimbabwe +263" }
  ];

  constructor(
    public dialogRef: MatDialogRef<AccessMethodsEditorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private overlay: Overlay,
    private userService: UserService,
    private cdRef: ChangeDetectorRef,
    private formBuilder: FormBuilder
  ) {

    this.userOwnerId = data.userOwnerId;

    this.accessMethodTypes = [
      { value: AccessMethod.EVENT_TYPE_REMOTE, text: $localize`:@@accessMethodsEditor_remote:Radiocomando JCM` },
      { value: AccessMethod.EVENT_TYPE_REMOTE1CONTROL, text: $localize`:@@accessMethodsEditor_remote1Control:Radiocomando 1Control` },
      { value: AccessMethod.EVENT_TYPE_PHONE, text: $localize`:@@accessMethodsEditor_phone:Telefono` },
      { value: AccessMethod.EVENT_TYPE_CAR, text: $localize`:@@accessMethodsEditor_car:Targa` },
      { value: AccessMethod.EVENT_TYPE_BADGE, text: $localize`:@@accessMethodsEditor_badge:Badge` },
      { value: AccessMethod.EVENT_TYPE_PINCODE, text: $localize`:@@accessMethodsEditor_pincode:Codice PIN` }
    ]
    // creo una copia per non modificare l'originale
    for (let accessMethod of data.accessMethodData) {
      this.methods.push(accessMethod);
    }
    for (let accessMethod of this.methods) {
      if (accessMethod.type == AccessMethod.EVENT_TYPE_APP) {
        this.appCode = accessMethod.code;
      } else if (accessMethod.type == AccessMethod.EVENT_TYPE_PHONE) {
        this.items.push(this.createItemPhone(accessMethod));
      } else {
        this.items.push(this.createItem(accessMethod));
      }
    }
    this.accessMethodsForm = this.formBuilder.group({
      items: this.items
    });
  }

  ngOnInit(): void { }

  ngAfterViewInit() {
  }

  closeDialog() {
    this.dialogRef.close();
  }

  createItem(accessMethod: AccessMethod): FormGroup {
    return new FormGroup({
      code: new FormControl(accessMethod.code),
      prefix: new FormControl(),
      type: new FormControl(this.getAccessMethodType(accessMethod.type))
    });
  }

  getAccessMethodType(type: string) {
    for (let i = 0; i < this.accessMethodTypes.length; i++) {
      if (this.accessMethodTypes[i].value == type) {
        return this.accessMethodTypes[i];
      }
    }
  }

  createItemPhone(accessMethod: AccessMethod): FormGroup {
    Log.debug(accessMethod);

    let phone = this.phoneUtil.parse(accessMethod.code);
    Log.debug(phone);

    let phoneNumber = phone.getNationalNumber().toString();
    Log.debug(phoneNumber);

    if (phone.hasItalianLeadingZero()) {
      Log.debug("hasItalianLeadingZero");
      phoneNumber = "0" + phoneNumber;
    }

    let prefix = "+" + phone.getCountryCode();

    return new FormGroup({
      code: new FormControl(phoneNumber),
      prefix: new FormControl(prefix),
      type: new FormControl(this.accessMethodTypes[2])
    });
  }

  addEmptyItem(): void {
    this.tooManyRemotesError = false;
    this.currentRemotes = 0;

    for (let i = 0; i < this.items.controls.length; i++) {
      if (this.items.controls[i].value.type.value == AccessMethod.EVENT_TYPE_REMOTE) {
        this.currentRemotes++;
        if (this.currentRemotes == this.maxRemotes) {
          let message = $localize`:@@accessMethodsEditor_too_many_remotes_message: Ad ogni utente é possibile associare un massimo di 15 radiocomandi`;
          let header = $localize`:@@accessMethodsEditor_too_many_remotes_warning: Attenzione`;

          const scrollStrategy = this.overlay.scrollStrategies.reposition();

          const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: "350px",
            data: { message, header },
            scrollStrategy,
          });

          dialogRef.afterClosed().subscribe((response) => {

          });
        }
      }
    }

    this.items.controls.push(new FormGroup({
      code: new FormControl(),
      prefix: new FormControl(),
      type: new FormControl(this.accessMethodTypes[0])
    }));
  }

  containsAnyLetters(methodCode) {
    return /[a-zA-Z]/.test(methodCode);
  }

  saveAccessMethods() {

    this.loader.showLoading();

    this.emptyCodeError = false;
    this.duplicateError = false;
    this.remoteCodeError = false;
    this.wrongPhoneNumberError = false;
    this.tooManyRemotesError = false;
    this.tooManyMethodsError = false;
    this.pincodeHasLettersError = false;
    this.pincodeLengthError = false;
    this.methodAlreadyUsedError = false;
    this.methods = [];

    let appMethod: AccessMethod = new AccessMethod();
    appMethod.code = "App";
    appMethod.type = "App";
    this.methods.push(appMethod);

    if (this.items.controls.length > this.maxMethods) {
      this.tooManyMethodsError = true;
      this.loader.hideLoading();
    } else {

      for (let i = 0; i < this.items.controls.length; i++) {

        let accessMethod = new AccessMethod();

        if (this.items.controls[i].value.type.value == AccessMethod.EVENT_TYPE_PINCODE) {
          if (!this.containsAnyLetters(this.items.controls[i].value.code)) {
            accessMethod.code = this.items.controls[i].value.code;
          } else {
            this.pincodeHasLettersError = true;
            break;
          }

          if (this.items.controls[i].value.code < 100000 || this.items.controls[i].value.code > 999999) {
            this.pincodeLengthError = true;
            break;
          } else {
            accessMethod.code = this.items.controls[i].value.code;
          }
        }


        if (this.items.controls[i].value.type.value == AccessMethod.EVENT_TYPE_PHONE) {
          let numberToCheck = this.phoneUtil.parse(this.items.controls[i].value.prefix + this.items.controls[i].value.code.replace(/\D/g, ''));
          if (this.phoneUtil.isValidNumber(numberToCheck)) {
            // this.items.controls[i].value.code = this.phoneUtil.format(numberToCheck, PhoneNumberFormat.E164);
            accessMethod.code = this.phoneUtil.format(numberToCheck, PhoneNumberFormat.E164);
          } else {
            this.wrongPhoneNumberError = true;
            break;
          }
        } else if (this.items.controls[i].value.type.value == AccessMethod.EVENT_TYPE_REMOTE1CONTROL) {
          accessMethod.code = this.items.controls[i].value.code.toUpperCase();
        } else {
          accessMethod.code = this.items.controls[i].value.code;
        }

        accessMethod.type = this.items.controls[i].value.type.value;


        this.methods.push(accessMethod);
      }


      this.methodsToCheck = [];
      // creo una copia per non modificare l'originale
      for (let m of this.methods) {
        // this.methodsToCheck.push(Object.create(m));
        this.methodsToCheck.push(Object.assign({}, m));
      }

      this.currentRemotes = 0;

      if (!this.pincodeHasLettersError && !this.pincodeLengthError && !this.wrongPhoneNumberError) {
        this.checkAccessMethodDuplicate(0);
      } else {
        this.loader.hideLoading();
      }
    }
  }

  deleteItem(i: number): void {
    Log.debug("clicked deleteItem ");
    this.items.controls.splice(i, 1);
  }

  showGuide() {
    const scrollStrategy = this.overlay.scrollStrategies.reposition();
    const dialogRef = this.dialog.open(AccessMethodsGuideComponent, {
      width: "450px",
      scrollStrategy
    });
  }

  isPhoneType(index: number): boolean {
    if (this.items.controls[index].value.type.value == AccessMethod.EVENT_TYPE_PHONE) {
      return true;
    } else {
    }
    return false;
  }

  checkAccessMethodDuplicate(index): void {

    Log.debug("checkAccessMethodDuplicate");

    if (index < this.methodsToCheck.length) {

      let accessMethod = this.methodsToCheck[index];

      if (accessMethod.type == AccessMethod.EVENT_TYPE_REMOTE) {
        this.currentRemotes++;
        accessMethod.code = RemoteHelper.jcmCodeToStandardCode(accessMethod.code).toString();
      }

      if (accessMethod.type == AccessMethod.EVENT_TYPE_REMOTE1CONTROL) {
        this.currentRemotes++;
      }

      if (accessMethod.type != AccessMethod.EVENT_TYPE_APP) {

        this.userService.isMethodUsedCheck(this.userOwnerId, accessMethod).subscribe((data) => {

          Log.debug("checkAccessMethodDuplicateData: ");
          Log.debug(data);

          if (data) {
            Log.debug("current remotes: " + this.currentRemotes);
            if (this.currentRemotes > this.maxRemotes) {
              this.tooManyRemotesError = true;
              this.checkAccessMethodDuplicateFinish(false);
            } else {
              this.checkAccessMethodDuplicate(index + 1);
            }
          } else {

            Log.debug("duplicate method");
            if (accessMethod.type == AccessMethod.EVENT_TYPE_REMOTE) {
              this.methodStr = RemoteHelper.standardCodeToJcmCode(accessMethod.code).toString();
              this.methodAlreadyUsedError = true;
            }
            else {
              this.methodStr = accessMethod.code;
              this.methodAlreadyUsedError = true;
            }

            this.checkAccessMethodDuplicateFinish(false);
          }
        });

      } else {

        Log.debug("type == app, result = true");
        this.checkAccessMethodDuplicate(index + 1);
      }

    } else {
      this.checkAccessMethodDuplicateFinish(true);
    }

  }

  checkAccessMethodDuplicateFinish(result) {
    if (result) {
      for (let i = 0; i < this.methods.length; i++) {
        for (let j = 0; j < this.methods.length; j++) {
          if (i == j) {
            continue;
          } if (this.methods[i].code == this.methods[j].code && this.methods[i].type == this.methods[j].type) {
            this.duplicateError = true;
            break;
          } if (this.methods[i].code == null || this.methods[i].code == "") {
            this.emptyCodeError = true;
            break;
          } if (this.methods[i].type == AccessMethod.EVENT_TYPE_REMOTE && (parseInt(this.methods[i].code) < 9999 || parseInt(this.methods[i].code) > 999999)) {
            this.remoteCodeError = true;
            break;
          }
        }
        if (this.emptyCodeError || this.duplicateError || this.remoteCodeError || this.wrongPhoneNumberError) {
          break;
        }
      }
    }
    this.loader.hideLoading();
    if (this.emptyCodeError) {
      Log.debug("Errore campo vuoto");
    } else if (this.tooManyRemotesError) {
      Log.debug("Errore troppi radiocomandi");
    } else if (this.duplicateError) {
      Log.debug("Errore dati duplicati");
    } else if (this.remoteCodeError) {
      Log.debug("Errore codice radiocomando");
    } else if (this.wrongPhoneNumberError) {
      Log.debug("Errore numero di telefono");
    } else if (this.methodAlreadyUsedError) {
      Log.debug("methodAlreadyUsedError: " + this.methodAlreadyUsedError);
    } else if (this.pincodeHasLettersError) {
      Log.debug("Errore pincode con lettere");
    } else if (this.pincodeLengthError) {
      Log.debug("Errore lunghezza pincode");
    } else {
      this.dialogRef.close({ methods: this.methods });
    }
  }
}
